module.exports = function() {
  return new Worker(__webpack_public_path__ + "a934721182a1de40581c.worker.js");
};